module.exports = __webpack_public_path__ + "static/img/play.dd8460c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play.png
// module id = RBJf
// module chunks = 1